import { render, staticRenderFns } from "./AdminDetail.vue?vue&type=template&id=1fe3986e&"
import script from "./AdminDetail.vue?vue&type=script&lang=js&"
export * from "./AdminDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports